<!-- Warranty -->
<ng-container *ngIf="(productHasWarranties$ | async) && pli">
  <div class="row">
    <!-- check if warranty can be edited, else only display its name -->
    <div
      class="list-item"
      [ngClass]="
        OnePageCheckout ? 'col-md-10 pt-1' : editable ? 'col-md-6 offset-1 pt-3 pl-5' : 'col-md-7 offset-1 pt-3 pl-5'
      "
    >
      <ish-product-warranty
        (submitWarranty)="updateLineItemWarranty($event)"
        [selectedWarrantySku]="pli.warranty?.sku"
        [viewType]="editable ? 'select' : 'display'"
      />
    </div>
    <ng-container *ngIf="pli.warranty">
      <!-- Warranty Single Price: ToDo - is not yet available -->
      <div
        [ngClass]="{
          'col-md-2 d-none d-md-block list-item pt-3 column-price single-price': !OnePageCheckout,
          'd-none': OnePageCheckout
        }"
      ></div>

      <!-- Warranty Total Price -->
      <div class="col-3 col-md-2 pt-3 list-item column-price">{{ pli.warranty.price | ishPrice }}</div>
    </ng-container>
  </div>
</ng-container>
